export const SUPPORT_EMAIL = 'imran@playgroundlogic.com';
export const COMPANY_LEGAL_NAME = 'Playground Logic Sdn Bhd';
export const COMPANY_REGISTRATION_NUMBER = '202501023100 (1624513-K)';
export const TRUST_PAGES_LAST_UPDATED = 'Feb 24, 2026';

export const ABOUT_PAGE_SECTIONS = Object.freeze([
  {
    heading: 'What Zoomed In Is',
    paragraphs: Object.freeze([
      'Zoomed In is a puzzle app for short rounds. You guess words from zoomed images, riddles, and clues.',
      
    ]),
  },
  {
    heading: 'Gameplay Modes',
    paragraphs: Object.freeze([
      'Each mode solves a different play style. Daily is a shared puzzle, every player gets the same one every day. Unlimited is replay-focused, great for easy going rounds, and for practicing. Riddled-In is a riddle focused guessing game, and Earth is location-based.',
    ]),
  },
  {
    heading: 'How We Review Quality',
    paragraphs: Object.freeze([
      'Before shipping changes, we test answer validation, clue reveal behavior, and image readability in browser gameplay.',
      'When players report mismatches or inappropriate content, we review the report, adjust puzzle data, and patch affected flows.',
    ]),
  },
  {
    heading: 'Content Sources and Project Support',
    paragraphs: Object.freeze([
      'Some modes use third-party image or map providers. We use those sources inside app-specific puzzle logic rather than reposting content as-is.',
      'The project is supported by optional coin purchases and advertising. Core puzzle play paths remain available without payment.',
    ]),
  },
]);

export const CONTACT_PAGE_SECTIONS = Object.freeze([
  {
    heading: 'Support and Feedback',
    paragraphs: Object.freeze([
      'If you need help, found a bug, or have a feature suggestion, send us an email. We review support messages and use them to prioritize fixes.',
    ]),
  },
  {
    heading: 'What to Include for Faster Help',
    paragraphs: Object.freeze([
      'For faster troubleshooting, include your device, browser, route or game mode, and the exact step where the issue happened.',
    ]),
  },
]);

export const CONTACT_HELP_CHECKLIST = Object.freeze([
  'Device type (mobile or desktop) and OS',
  'Browser and version',
  'Game mode or page URL',
  'Time of issue and any error message shown',
  'Screenshots if available',
]);

export const CONTACT_RESPONSE_GUIDELINE =
  'Typical response time is within 2-3 business days for standard support requests.';
